var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconChristmasTree = function SvgIconChristmasTree(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 588.245 777.3938",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 270.1691,
    y: 612.84,
    width: 47.8951,
    height: 158.6313,
    style: {
      fill: "#623b20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.9417,733.6163v68.085c-6.6749-1.155-13.5-4.08-19.68-6.87-8.7749-3.96-19.35-7.44-28.2151-5.475v-55.74Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#522a1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.7568,731.0663c-8.31,4.74-15.69-1.485-24.1051-.885-8.1749.6-10.0349,8.28-16.2,13.305-4.7849,3.9-10.7549,6.57-16.9349,6.585-11.295.015-16.875-8.175-27.3.57-3.36,2.805-6.405,6.135-10.3649,8.04-10.0351,4.83-17.175-1.65-26.61-1.62-8.67.03-17.145,8.295-25.815,10.395-8.19,1.995-15.1651.69-22.875-2.16-6.18-2.28-3.885-3.225-9.765.525-3.315,2.115-5.58,5.22-9.33,6.87-6.12,2.67-13.29,2.025-19.5449-.315-5.625-2.1-13.2751-9.96-18.81-9.48-6.15.555-12.5552,8.085-19.005,9.6a31.7177,31.7177,0,0,1-26.37-6c-5.835-4.605-5.13-7.08-12.66-5.685-7.395,1.365-13.65,4.89-21.4948,4.935-11.3252.045-14.7-5.82-22.83-11.295-7.5-5.01-13.83,3.465-22.6952,3.24-11.28-.33-13.89-11.01-22.59-13.89-7.53-2.49-15.45,7.095-24.0448,5.085-4.56-1.065-8.1152-4.5-11.4152-7.8-3.375-3.36-7.17-9.135-11.8348-9.615-4.0052-.405-8.8052,3.93-13.05,4.23a10.9152,10.9152,0,0,1-9.45-4.455c-7.62-10.74,10.17-25.365,16.14-33.15l.0148-.015q13.05-17.01,25.5-34.455,25.11-35.1225,47.94-71.775c.405-.645.8248-1.305,1.23-1.98.27-.435.54-.855.7948-1.29q5.2425-8.415,10.3352-16.905,5.1747-8.64,10.245-17.355,7.3575-12.6,14.445-25.365a1561.9461,1561.9461,0,0,0,98.235-214.245,1563.7243,1563.7243,0,0,0,98.2349,214.245q12.0151,21.6,24.69,42.72,4.8152,8.01,9.735,15.96c.4651.75.93,1.5,1.38,2.235.4051.675.825,1.335,1.23,1.98q23.2426,37.26,48.825,72.99,12.9375,18.0675,26.49,35.655c3.975,5.16,13.335,13.395,14.865,20.73C726.7568,724.8863,725.5568,728.3513,720.7568,731.0663Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#19a553"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.1893,556.9487q2.2878-.3611,4.5758-.7221c.6263-.6718,1.2435-1.3525,1.8735-2.0211Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#1eb45c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.0317,661.7363c.795,10.935-.27,23.385-8.67,30.435-7.89,6.63-23.22,2.415-23.97-7.14-.3,13.08-1.3651,27.06-10.0051,36.75-9.06,10.17-29.55,9.975-33.405-3.09,3.045,11.775-9.1049,24.585-21.015,22.2-11.9249-2.4-18.1649-18.915-10.815-28.59q-7.02,2.0025-14.0249,4.02c-1.35-2.655-2.715-5.295-4.08-7.95-2.0249,2.31-4.05,4.605-6.0749,6.915q-4.23-5.3325-8.46-10.65c-1.935,8.43-6.555,17.235-14.79,19.845-7.215,2.295-16.29-3.66-16.29-10.545-1.59,7.83-3.735,15.765-9.165,21.525-6.105,6.495-17.8952,8.475-23.61,1.62-9.4348-11.31,6.36-30.93-1.7248-42.57,3.3448,5.28-1.65,13.725-8.235,14.19-7.065.495-13.2-5.655-15.1652-12.465-1.74-5.955-1.02-12.285-.0148-18.45-1.0652,6.045-2.5952,12.165-6.6752,16.65-4.6648,5.115-13.92,6.69-18.2548,1.29-7.65-9.495,7.86-24.255,2.055-34.965-14.5352-.99-23.91,14.385-31.3652,26.91-7.4548,12.51-22.0948,25.605-34.68,18.285a16.77,16.77,0,0,1-6.795-7.86l.0148-.015q13.05-17.01,25.5-34.455,25.11-35.1225,47.94-71.775c.405-.645.8248-1.305,1.23-1.98.27-.435.54-.855.7948-1.29q5.2425-8.415,10.3352-16.905,5.1747-8.64,10.245-17.355,54.855-8.6625,109.74-17.325c22.41-3.54,45.33-7.065,67.65-3.03,22.335,4.02,44.34,17.115,52.89,38.13,3.8249,9.405,4.14,21.57-3.4351,28.305-4.0649,3.63-10.4549,3.645-15.21,1.335A149.1781,149.1781,0,0,1,617.0317,661.7363Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#1eb45c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.2029,587.6342c-1.1049,2.35-2.3076,4.7828-4.755,6.2511-5.9853,3.594-7.8311-2.07-12.7536-3.594-6.1535-1.902-5.9855,5.2163-10.7822,7.5375-3.6639,1.79-8.0271.6434-11.9566-.4753-6.6006-1.874-8.3768-1.7061-12.1247,2.9926-3.4263,4.3073-7.272,7.4118-12.7818,8.7822a24.3211,24.3211,0,0,1-14.88-1.1467c-4.8945-1.9857-7.8453-7.9151-12.18-3.552-5.1324,5.1883-11.5651,10.1248-19.0749,10.824A25.7844,25.7844,0,0,1,507.37,611.8c-4.8666-2.6431-10.2225-9.9709-15.5507-8.2509-6.1113,1.9857-9.5236,7.9712-16.6554,8.8521-5.3423.6713-10.7823-.9648-15.495-3.594-5.3142-2.9787-11.3414-12.1525-17.3129-8.4327-3.3142,2.07-6.0411,4.9785-9.8589,6.1812-4.4751,1.3985-9.4815.084-13.3972-2.5032-3.4122-2.2515-7.5237-10.1247-11.4252-10.5583-2.0559-.2376-4.755,2.8528-6.5589,3.636a14.5556,14.5556,0,0,1-8.6984,1.1328c-6.265-1.2167-6.6286-5.6778-10.6141-9.048-3.3-2.7969-9.3138.6993-14.3061-.5733-.07-.014-.14-.042-.21-.056q5.2232-8.4118,10.3347-16.9072,12.67-21.1026,24.6825-42.7227A1563.4723,1563.4723,0,0,0,500.5459,314.713a1563.3794,1563.3794,0,0,0,98.227,214.2423q12.0195,21.606,24.6966,42.7227Q628.2731,579.6909,633.2029,587.6342Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#0d823f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.0317,559.8413c-7.53,4.53-13.6649-2.325-21.12-2.49-7.95-.15-6.45,9.27-12.465,12.885-5.985,3.6-7.83-2.07-12.75-3.6-6.15-1.89-5.985,5.22-10.785,7.545-3.66,1.785-8.0251.645-11.9551-.48-6.6-1.875-8.3849-1.695-12.12,3-3.4351,4.305-7.2751,7.41-12.795,8.775a24.2632,24.2632,0,0,1-14.865-1.14c-4.905-1.995-7.86-7.92-12.1951-3.555-5.13,5.19-11.5649,10.125-19.0649,10.83a25.8155,25.8155,0,0,1-14.55-3.465c-4.86-2.64-10.2151-9.96-15.54-8.25-6.12,1.995-9.5249,7.98-16.6649,8.85-5.34.675-10.785-.96-15.495-3.585-5.31-2.985-11.34-12.15-17.31-8.43-3.3148,2.07-6.045,4.98-9.8548,6.18-4.485,1.395-9.48.075-13.3952-2.505-3.42-2.25-7.53-10.125-11.43-10.56-2.0552-.24-4.7552,2.85-6.5552,3.63a14.502,14.502,0,0,1-8.7,1.14c-6.27-1.215-6.63-5.685-10.62-9.045-3.3-2.805-9.315.69-14.31-.585-5.8052-1.47-7.59-5.46-11.94-8.52-3.765-2.64-6.315-.84-10.7552.57-3.12.99-6.69,1.335-9.5248-.315-9.54-5.505,8.145-21.06,11.8648-25.89q5.355-6.9975,10.56-14.085,6.03-8.19,11.88-16.515c.1352-.195.2852-.405.42-.6.51-.72,1.0052-1.425,1.5-2.145q20.97-29.9475,39.735-61.395c1.485-2.52,2.985-5.04,4.47-7.575.24-.405.48-.825.72-1.23.99-1.695,1.965-3.39,2.94-5.07q1.9122-3.33,3.7948-6.63,2.1828-3.825,4.32-7.68c.2248-.39.45-.795.6748-1.2.8552-1.53,1.6952-3.06,2.535-4.605q3.2853-5.9625,6.48-11.985,8.8422-16.605,17.16-33.555a1172.004,1172.004,0,0,0,46.2152-107.715,1152.5165,1152.5165,0,0,0,72.39,157.86c.2249.405.45.81.6749,1.2q2.1375,3.8475,4.32,7.68c1.26,2.205,2.505,4.41,3.78,6.63.0451.06.09.15.135.225h.015q1.7325,3.0375,3.54,6.075c1.455,2.535,2.955,5.055,4.455,7.575q20.2725,33.9075,43.095,66.195,11.34,15.975,23.31,31.515c3,3.9,8.46,9.36,10.3349,14.73C668.0168,552.5963,667.3867,556.6163,662.0317,559.8413Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#19a553"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.9367,506.2463c-4.035-.39-6.66-4.56-10.47-5.925-8.55-3.075-14.85,8.67-14.85,17.745-.015,9.09.99,20.325-6.795,25.005l-30.645-14.535c4.545,10.05-2.7751,23.46-13.6951,25.08-10.905,1.605-21.795-9.12-20.34-20.055-3.165,8.64-6.57,17.655-13.53,23.685-6.945,6.015-18.6152,7.65-24.96.99-4.605-4.83-5.0248-12.165-7.11-18.525-2.0852-6.345-8.2952-12.84-14.535-10.425-2.985,1.155-4.905,4.005-7.53,5.835a12.134,12.134,0,0,1-14.7752-19.215c-6.45-7.095-18.3-1.665-25.155,5.04-6.855,6.69-14.8348,15.18-24.18,12.975-6.51-1.53-10.8-8.205-11.5352-14.85a20.38,20.38,0,0,1-.1348-2.325q6.03-8.19,11.88-16.515c.1352-.195.2852-.405.42-.6.51-.72,1.0052-1.425,1.5-2.145q20.97-29.9475,39.735-61.395c1.485-2.52,2.985-5.04,4.47-7.575.24-.405.48-.825.72-1.23.99-1.695,1.965-3.39,2.94-5.07q1.9122-3.33,3.7948-6.63,2.1828-3.825,4.32-7.68c.2248-.39.45-.795.6748-1.2.8552-1.53,1.6952-3.06,2.535-4.605a130.879,130.879,0,0,1,34.905-17.565c24.3451-7.815,51.9751-7.125,74.49,5.01,35.04,18.885,50.88,59.805,63.99,97.395C606.7418,494.6063,606.0068,507.0563,597.9367,506.2463Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#1eb45c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.8376,422.4355a5.0706,5.0706,0,0,0-3.58.4755c-4.2513,2.3913-5.0344,7.23-10.67,8.1808-3.6638.6294-6.88-.4753-10.0269-2.2515-3.79-2.14-2.7828-3.1464-6.5865-.3355-4.671,3.4681-6.7967,7.9572-13.2434,8.6284-5.538.5873-9.23-1.65-13.9006-4.0416-5.86-2.9787-5.1464-.6013-10.1247,2.8529a19.9751,19.9751,0,0,1-22.9767.07c-2.8806-1.9718-4.5449-6.5307-8.0831-4.3352-4.2093,2.6012-7.6355,4.8666-12.88,4.4891-7.3559-.5315-12.2085-10.3487-18.1519-7.7754-3.6082,1.5522-6.5726,3.0067-10.6841,2.5452-4.9785-.5735-7.1462-3.4263-10.8939-6.0833-4.3773-3.1186-4.0416-1.1607-9.0618,1.1886a12.57,12.57,0,0,1-4.559,1.2447c.9928-1.6921,1.9716-3.3843,2.95-5.0763q1.9092-3.3144,3.79-6.6286,2.1814-3.8178,4.3212-7.6776c.2238-.3915.4477-.7971.6712-1.2027A1151.6035,1151.6035,0,0,0,500.5459,248.846,1151.5107,1151.5107,0,0,0,572.93,406.7029c.2238.4056.4476.8112.6712,1.2027q2.14,3.86,4.3214,7.6776,1.8878,3.3143,3.79,6.6286C581.7539,422.2817,581.7959,422.3656,581.8376,422.4355Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#0d823f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.8818,395.0663c-4.77,3.285-9.09-1.11-13.365.51-3.6451,1.35-4.86,6.63-9.45,7.98-6.195,1.83-11.3549-4.425-15.81-1.92-4.2451,2.4-5.04,7.23-10.6651,8.19-3.6749.63-6.885-.48-10.0349-2.25-3.78-2.145-2.7751-3.15-6.585-.345-4.665,3.465-6.795,7.965-13.245,8.625-5.5351.6-9.225-1.65-13.89-4.035-5.865-2.985-5.16-.6-10.125,2.85a20.01,20.01,0,0,1-22.98.075c-2.88-1.98-4.545-6.54-8.0849-4.335-4.215,2.595-7.6352,4.86-12.8852,4.485-7.35-.525-12.21-10.35-18.15-7.77-3.6,1.545-6.57,3-10.68,2.535-4.98-.57-7.1552-3.42-10.89-6.075-4.38-3.12-4.05-1.17-9.0752,1.185-7.9948,3.735-12.705-1.5-17.7448-6.96-4.305-4.68-4.215-1.965-10.125-.375-3.3152.885-7.05.72-9.87-1.215-4.98-3.435-3.24-7.605-.18-11.46,2.0852-2.655,4.8152-5.16,6.36-7.185,1.02-1.32,2.0252-2.625,3.03-3.96q7.02-9.225,13.6952-18.675,16.4022-23.175,30.9448-47.565,5.94-9.945,11.595-20.115c.09-.15.18-.315.2552-.465.99-1.785,1.98-3.57,2.97-5.37.345-.645.69-1.29,1.035-1.92q3.555-6.57,7.0048-13.245,5.76-11.115,11.1752-22.47c.1048-.225.225-.465.33-.69,10.68-22.395,20.3851-45.405,29.1-68.85a831.6235,831.6235,0,0,0,40.605,92.01c2.205,4.245,4.425,8.475,6.705,12.66.435.84.885,1.665,1.35,2.505.9751,1.8,1.9651,3.585,2.955,5.37a3.4284,3.4284,0,0,1,.24.465q5.67,10.1475,11.61,20.115,14.22,23.8275,30.21,46.53,7.785,11.025,15.975,21.75c2.2951,2.985,7.5451,7.68,9.12,12.15C620.2418,390.4463,619.8968,392.9963,616.8818,395.0663Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#19a553"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.0817,351.6113c-.0749,4.815-2.55,9.93-7.0649,11.625a8.2441,8.2441,0,0,1-7.62-1.29c1.8,6.975-1.575,15.42-8.355,18.24-7.35,3.06-16.5151-1.365-19.6351-8.475.5851,7.29-5.16,14.955-12.5849,16.545-8.82,1.89-18.1351-3.57-22.515-11.46a31.6005,31.6005,0,0,1-3.57-16.995c-3.12,5.475-9.72,9.225-15.78,7.14-9.18-3.15-10.59-18.495-1.875-22.785-10.89-1.86-20.04,7.74-26.6848,16.56-6.645,8.835-15,18.81-26.0252,18.12a16.61,16.61,0,0,1-10.935-5.22q7.02-9.225,13.6952-18.675,16.4022-23.175,30.9448-47.565,5.94-9.945,11.595-20.115c.09-.15.18-.315.2552-.465.99-1.785,1.98-3.57,2.97-5.37.345-.645.69-1.29,1.035-1.92q3.555-6.57,7.0048-13.245,5.76-11.115,11.1752-22.47a35.7355,35.7355,0,0,1,13.755-.675c13.68,2.04,25.5,11.175,33.795,22.275,8.28,11.085,13.53,24.09,18.69,36.945q7.0873,17.685,14.19,35.355C553.3417,342.1613,555.1717,346.7813,555.0817,351.6113Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#1eb45c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.8554,278.9267a10.1468,10.1468,0,0,1-3.8176.9228c-5.0486.2519-9.4118-3.8037-13.2575.5876-1.8178,2.0836-1.0209,4.0834-3.8875,5.5938-2.825,1.4962-6.7827.5872-9.4815-.7274-5.44-2.643-5.5938-6.3489-10.7543-2.643-2.9506,2.1117-3.8457,4.517-8.0688,4.3911-8.6287-.28-10.7962-13.6209-18.7535-5.356a8.3208,8.3208,0,0,1-8.2368,2.14c-4.7686-1.4543-3.9856-5.2722-8.67-5.4819-3.8178-.1818-6.405,2.1117-9.999,1.1467q3.5661-6.5657,7.0062-13.2433a829.0622,829.0622,0,0,0,40.6111-92.0039,831.6467,831.6467,0,0,0,40.597,92.0039C543.3526,270.508,545.5759,274.7314,547.8554,278.9267Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#0d823f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.9618,250.6013c-.4351,1.785.2249,4.56-1.59,6.195a8.102,8.102,0,0,1-5.5349,1.665c-3.6451,0-6.8251-2.52-10.23-1.155-4.29,1.71-6.12,5.475-11.5649,5.76-5.055.255-9.42-3.795-13.26.6-1.83,2.07-1.035,4.065-3.8849,5.58-2.8351,1.5-6.78.585-9.48-.72-5.445-2.655-5.61-6.345-10.755-2.64-2.9551,2.115-3.855,4.515-8.07,4.38-8.625-.27-10.8-13.62-18.75-5.355a8.3016,8.3016,0,0,1-8.235,2.145c-4.77-1.455-3.99-5.265-8.685-5.49-4.425-.21-7.1848,2.925-11.8348.42-2.88-1.56-4.71-5.205-8.13-5.76-4.4848-.735-7.2148,5.34-12.225,1.92-2.4748-1.68-2.7-4.44-1.65-7.65,2.76-8.55,14.52-20.415,17.445-24.66,8.1152-11.79,15.63-24,22.59-36.525a495.48,495.48,0,0,0,29.34-63.06c.72-1.815,1.41-3.645,2.0851-5.475a499.5179,499.5179,0,0,0,31.4249,68.535A427.4616,427.4616,0,0,0,572.9618,250.6013Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#19a553"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.9967,241.8113c-5.235,6.36-16.185,4.875-21.72-1.215-5.52-6.09-6.7049-14.985-6.2549-23.205-5.175-1.14-8.34,5.865-7.8,11.145s2.46,11.175-.63,15.48c-2.58,3.615-7.905,4.365-12.06,2.79-4.14-1.575-7.32-4.95-10.08-8.43a8.475,8.475,0,0,1-15.45,6.915c-1.4552-2.835-1.3652-6.555-3.72-8.7-3.45-3.135-9.12-.36-11.8648,3.39-2.52,3.48-4.08,7.83-7.3352,10.515,2.76-8.55,14.52-20.415,17.445-24.66,8.1152-11.79,15.63-24,22.59-36.525a495.48,495.48,0,0,0,29.34-63.06q14.13,47.1825,28.23,94.335C528.8018,227.6663,530.6768,236.1113,525.9967,241.8113Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#1eb45c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.295,501.4258a4.7321,4.7321,0,0,1-9.315-1.5356,4.7382,4.7382,0,0,1,9.315,1.5356Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.6657,503.1892a4.7329,4.7329,0,0,1-9.366-1.1864,4.7374,4.7374,0,0,1,9.366,1.1864Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.09,504.4911a4.7334,4.7334,0,0,1-9.4005-.8725,4.7369,4.7369,0,0,1,9.4005.8725Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.5491,505.3482a4.7375,4.7375,0,1,1-4.4554-4.61A4.54,4.54,0,0,1,416.5491,505.3482Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.0292,505.7573a4.7385,4.7385,0,1,1-4.6051-4.4435A4.5458,4.5458,0,0,1,430.0292,505.7573Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.3492,505.6191a6.3424,6.3424,0,0,1-6.5564,6.2818c-3.7353.0384-6.7427-2.6806-6.7178-6.0911a6.6629,6.6629,0,0,1,13.2742-.1907Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.809,504.9642a4.7329,4.7329,0,0,1-9.4264.5177,4.7371,4.7371,0,0,1,9.4264-.5177Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.2429,503.7827a4.7327,4.7327,0,0,1-9.3992.8817,4.7371,4.7371,0,0,1,9.3992-.8817Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.6134,502.0235a4.741,4.741,0,1,1-5.2574-3.6144A4.5263,4.5263,0,0,1,487.6134,502.0235Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.8976,499.7025a4.7337,4.7337,0,0,1-9.2839,1.7135,4.7363,4.7363,0,0,1,9.2839-1.7135Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.0484,496.7192a4.2147,4.2147,0,0,1-.5911,3.3551,4.91,4.91,0,0,1-3,1.9956,4.53,4.53,0,0,1-5.6015-3.2019,4.5765,4.5765,0,0,1,3.6051-5.2934,4.9054,4.9054,0,0,1,3.5088.511A4.1677,4.1677,0,0,1,514.0484,496.7192Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.6686,491.85c1.0864,3.21-.9532,6.7419-4.5569,7.8855a6.6852,6.6852,0,0,1-5.11-.4014,5.82,5.82,0,0,1-3.0475-3.6706,5.9721,5.9721,0,0,1,.7064-4.6852,7.1484,7.1484,0,0,1,3.9113-2.9931A6.4317,6.4317,0,0,1,530.6686,491.85Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.3262,487.2324a4.4462,4.4462,0,0,1-2.8724,5.7557,4.5093,4.5093,0,0,1-5.9675-2.4428,4.5981,4.5981,0,0,1,2.8859-5.7216A4.6671,4.6671,0,0,1,543.3262,487.2324Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.64,481.74a4.1751,4.1751,0,0,1,.0835,3.4,4.7036,4.7036,0,0,1-2.5374,2.61,4.5824,4.5824,0,0,1-6.1415-2.1126,4.5211,4.5211,0,0,1,2.5352-5.8341,5.1452,5.1452,0,0,1,3.498-.238A4.2077,4.2077,0,0,1,555.64,481.74Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.5572,475.4354a4.5687,4.5687,0,0,1-2.0244,6.169,4.8862,4.8862,0,0,1-1.8011.6175,4.9573,4.9573,0,0,1-1.8038-.15,4.1341,4.1341,0,0,1-2.8427-5.4769,4.5689,4.5689,0,0,1,.8863-1.48,5.2155,5.2155,0,0,1,1.4026-1.182A4.5353,4.5353,0,0,1,567.5572,475.4354Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.9908,468.2917a4.4861,4.4861,0,0,1-1.5888,6.247,4.4249,4.4249,0,0,1-6.3273-1.103,4.6923,4.6923,0,0,1,1.5984-6.2313A4.624,4.624,0,0,1,578.9908,468.2917Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.81,460.2475a4.1015,4.1015,0,0,1,.8553,3.2883,4.9539,4.9539,0,0,1-1.9444,3.0547,4.5064,4.5064,0,0,1-6.4293-.6357,4.6021,4.6021,0,0,1,1.1272-6.2956,4.8655,4.8655,0,0,1,3.3988-.9476A4.2906,4.2906,0,0,1,589.81,460.2475Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.5958,448.5755c2.4285,2.3633,2.191,6.471-.5363,9.1685-2.85,2.5606-7.0122,2.444-9.183-.1361a6.6771,6.6771,0,0,1,9.7193-9.0324Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.6935,672.9382a4.0733,4.0733,0,1,1-7.9119-1.8378,4.07,4.07,0,1,1,7.9119,1.8378Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.0546,675.2985a4.0707,4.0707,0,1,1-3.1116-5.07A4.2054,4.2054,0,0,1,330.0546,675.2985Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.4668,677.3979a4.0708,4.0708,0,1,1-3.224-5.0007A4.2068,4.2068,0,0,1,341.4668,677.3979Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.9207,679.2569a4.0709,4.0709,0,1,1-3.3275-4.933A4.2074,4.2074,0,0,1,352.9207,679.2569Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.41,680.8827a4.0709,4.0709,0,1,1-3.4267-4.8648A4.2072,4.2072,0,0,1,364.41,680.8827Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.2106,682.63a5.7241,5.7241,0,1,1-4.9762-6.72A5.9088,5.9088,0,0,1,379.2106,682.63Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.7539,683.72a4.0708,4.0708,0,1,1-3.6488-4.7A4.2069,4.2069,0,0,1,390.7539,683.72Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.3265,684.57a4.0708,4.0708,0,1,1-3.7467-4.6224A4.2065,4.2065,0,0,1,402.3265,684.57Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.9147,685.17a4.0708,4.0708,0,1,1-3.8458-4.54A4.2061,4.2061,0,0,1,413.9147,685.17Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.5133,685.5118a4.0707,4.0707,0,1,1-3.9467-4.4512A4.2055,4.2055,0,0,1,425.5133,685.5118Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.1168,685.5838a4.0707,4.0707,0,1,1-4.05-4.3573A4.2049,4.2049,0,0,1,437.1168,685.5838Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.0164,685.26a5.7283,5.7283,0,1,1-11.4186.291,5.7236,5.7236,0,1,1,11.4186-.291Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.5958,684.667a4.07,4.07,0,1,1-4.2943-4.1134A4.2038,4.2038,0,0,1,463.5958,684.667Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.1637,683.7581a4.07,4.07,0,1,1-4.4058-3.9937A4.2017,4.2017,0,0,1,475.1637,683.7581Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.7005,682.5155a4.07,4.07,0,1,1-4.52-3.8617A4.2017,4.2017,0,0,1,486.7005,682.5155Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.194,680.9214a4.0733,4.0733,0,1,1-8.04,1.1538,4.07,4.07,0,1,1,8.04-1.1538Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.63,678.957a4.0734,4.0734,0,1,1-7.9985,1.4146,4.07,4.07,0,1,1,7.9985-1.4146Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.2057,675.854a5.7293,5.7293,0,1,1-11.1588,2.4377,5.7225,5.7225,0,1,1,11.1588-2.4377Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.4336,672.9626a4.0736,4.0736,0,1,1-7.854,2.0713,4.07,4.07,0,1,1,7.854-2.0713Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.5471,669.6277a4.0737,4.0737,0,1,1-7.7653,2.382,4.07,4.07,0,1,1,7.7653-2.382Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.5108,665.8294a4.0738,4.0738,0,1,1-7.6577,2.708,4.07,4.07,0,1,1,7.6577-2.708Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.2936,661.5445a4.0741,4.0741,0,1,1-7.5277,3.0509,4.07,4.07,0,1,1,7.5277-3.0509Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.8618,656.7552a4.0741,4.0741,0,1,1-7.3732,3.4071,4.0694,4.0694,0,1,1,7.3732-3.4071Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.0608,649.84a5.7306,5.7306,0,1,1-10.0756,5.3785,5.7209,5.7209,0,1,1,10.0756-5.3785Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.9871,643.85a4.0743,4.0743,0,1,1-6.92,4.2528,4.0692,4.0692,0,1,1,6.92-4.2528Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.5751,637.3165a4.0744,4.0744,0,1,1-6.6733,4.63,4.0691,4.0691,0,1,1,6.6733-4.63Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.7737,630.2456a4.0745,4.0745,0,1,1-6.3965,5.0054,4.069,4.069,0,1,1,6.3965-5.0054Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.5411,622.6466a4.0746,4.0746,0,1,1-6.0906,5.3735,4.0689,4.0689,0,1,1,6.0906-5.3735Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.8385,614.5373a4.0745,4.0745,0,1,1-5.7578,5.7285,4.0688,4.0688,0,1,1,5.7578-5.7285Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.7537,603.4152a5.7313,5.7313,0,1,1-7.5231,8.593,5.72,5.72,0,1,1,7.5231-8.593Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.5549,355.8665c-.116,2.415-2.5257,4.2379-5.3818,4.0679-2.855-.1862-5.0175-2.3036-4.8318-4.7038.1859-2.405,2.593-4.1875,5.3779-4.0057C412.505,351.3905,414.67,353.4675,414.5549,355.8665Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.1659,356.34c-.0287,2.42-2.3715,4.3174-5.2331,4.2565-2.8607-.0851-5.0972-2.1265-4.9966-4.5313.1008-2.4106,2.4428-4.2753,5.2314-4.1923C426.9566,351.9321,429.1942,353.9408,429.1659,356.34Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.7843,356.2693c.063,2.4043-2.2077,4.4176-5.0715,4.4517-2.8635.0127-5.1743-1.9224-5.1612-4.3431.013-2.3988,2.284-4.3711,5.0722-4.3831C441.4114,351.9615,443.7212,353.8556,443.7843,356.2693Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.3886,355.6288c.16,2.4046-2.029,4.52-4.8925,4.6473-2.8624.1583-5.2486-1.7353-5.328-4.14-.08-2.4122,2.1148-4.4215,4.896-4.5758C455.8472,351.4365,458.2283,353.2245,458.3886,355.6288Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.9541,354.389c.2644,2.3945-1.8361,4.5732-4.692,4.8586-2.8589.2385-5.32-1.517-5.4981-3.92s1.9267-4.5391,4.7-4.77C470.232,350.28,472.69,351.993,472.9541,354.389Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.5526,351.828c.58,3.3252-2.2021,6.5985-6.2289,7.1826-4.0261.5868-7.6176-1.7539-8.013-5.1267-.3936-3.3586,2.4133-6.4582,6.2525-7.0183C487.4019,346.3092,490.9686,348.4763,491.5526,351.828Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.883,349.0033c.5371,2.357-1.3054,4.7844-4.13,5.3439-2.8165.6-5.4645-.9261-5.8958-3.2947-.4322-2.3729,1.4359-4.6765,4.1477-5.2551C502.7262,345.2592,505.3493,346.6612,505.883,349.0033Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.0487,345.3991c.6671,2.3-1.0293,4.86-3.822,5.5792-2.7939.7124-5.51-.6065-6.0691-2.9565-.5562-2.3388,1.1651-4.7994,3.8479-5.4828C516.6861,341.8492,519.3739,343.07,520.0487,345.3991Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.9761,340.9632c.8158,2.2675-.74,4.8653-3.4749,5.8008-2.7472.8937-5.5534-.3054-6.2461-2.6053-.6976-2.3148.8865-4.8282,3.5135-5.6825C530.3807,337.5816,533.16,338.6957,533.9761,340.9632Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.572,335.5983a4.012,4.012,0,0,1-.1616,3.4409,5.6786,5.6786,0,0,1-2.9167,2.5772c-2.6688,1.128-5.567.0687-6.405-2.1762-.8479-2.27.5847-4.8344,3.1222-5.9094a5.4718,5.4718,0,0,1,3.7788-.1677A4.1032,4.1032,0,0,1,547.572,335.5983Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.7414,329.26c1.1262,2.1035.0036,5.0047-2.6212,6.2426-2.6051,1.2788-5.5354.5181-6.5447-1.6956-.99-2.1718.21-4.9161,2.6785-6.1279C556.7441,326.5084,559.5936,327.1144,560.7414,329.26Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.8554,319.6422a5.6375,5.6375,0,0,1,.6345,4.8175,8.09,8.09,0,0,1-3.4762,4.3058,7.7382,7.7382,0,0,1-5.4246,1.1222,5.5232,5.5232,0,0,1-3.9875-2.7084,5.9,5.9,0,0,1-.3366-4.815,7.9569,7.9569,0,0,1,3.3318-4.0593,7.5854,7.5854,0,0,1,5.1413-1.1062A5.7764,5.7764,0,0,1,576.8554,319.6422Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.7729,233.62c.23,2.3945-1.0866,4.4975-2.9429,4.656-1.857.1457-3.51-1.6843-3.6912-4.0873s1.138-4.4659,2.9472-4.6076C439.8938,229.4272,441.5426,231.2173,441.7729,233.62Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.2314,232.6127c.29,2.3922-.9758,4.5039-2.8278,4.7162-1.8509.2231-3.55-1.5818-3.79-3.9812-.24-2.3962,1.03-4.475,2.83-4.6925C449.2454,228.4485,450.9412,230.22,451.2314,232.6127Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.6615,231.3673c.3542,2.3933-.8577,4.5315-2.7063,4.7776-1.8483.2487-3.59-1.4882-3.8914-3.8792s.9115-4.5252,2.7079-4.7668C458.5685,227.26,460.31,228.993,460.6615,231.3673Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.0514,229.8486c.4177,2.3666-.73,4.5768-2.5723,4.874-1.8437.287-3.6336-1.4117-3.9978-3.7938s.7916-4.539,2.5817-4.8172C467.8511,225.8233,469.6315,227.469,470.0514,229.8486Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.3968,228.0776c.4872,2.36-.6023,4.5729-2.4336,4.9422-1.8283.3862-3.6741-1.3129-4.1022-3.671-.433-2.3839.6722-4.5214,2.4423-4.8964C477.0768,224.0944,478.91,225.7176,479.3968,228.0776Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.3169,225.4045c.8209,3.2989-.5985,6.4874-3.1832,7.055-2.5811.585-5.2389-1.6234-5.94-4.9463-.6976-3.3089.73-6.4564,3.193-7.0143C487.8544,219.9585,490.5009,222.1264,491.3169,225.4045Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.5056,222.9761c.6564,2.3167-.27,4.6168-2.0734,5.1193-1.813.4619-3.7638-1.0574-4.357-3.3931s.345-4.59,2.0959-5.0356C497.91,219.1817,499.8482,220.6557,500.5056,222.9761Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.6167,220.2459c.7372,2.2942-.114,4.6112-1.9015,5.1747-1.782.5832-3.7971-.9211-4.4644-3.2237-.6743-2.3264.2036-4.56,1.9171-5.1229C506.8875,216.5313,508.8794,217.9517,509.6167,220.2459Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.6272,217.2c.8216,2.2654.052,4.604-1.7191,5.2227-1.7719.6165-3.8139-.7306-4.57-3.0353-.7461-2.2749.021-4.6215,1.7222-5.2137C515.761,213.58,517.8057,214.9348,518.6272,217.2Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.5193,213.8234c.91,2.2315.2272,4.59-1.5246,5.2663s-3.85-.6072-4.6869-2.8672-.1539-4.618,1.5247-5.2663S526.61,211.5919,527.5193,213.8234Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.2544,210.0593c1.0047,2.1963.4383,4.6266-1.2992,5.345-1.7294.7375-3.8822-.4687-4.8081-2.6936s-.3363-4.6,1.3172-5.3045C533.1269,206.7207,535.254,207.8729,536.2544,210.0593Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.2219,204.6812c1.5883,2.9935.9495,6.4181-1.4278,7.6471-2.3978,1.1818-5.5315-.42-6.9569-3.4825-1.4349-3.0819-.7435-6.4038,1.4966-7.5078C542.5492,200.19,545.6337,201.6877,547.2219,204.6812Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.9509,537.6405a4.2186,4.2186,0,1,1-4.2186-4.2187A4.2186,4.2186,0,0,1,505.9509,537.6405Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#38352d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 295.8548,
    cy: 432.5496,
    r: 15.6854,
    style: {
      fill: "#f44336"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.391,555.67a15.6783,15.6783,0,0,1,25.5382-12.197,15.68,15.68,0,1,0-22.05,22.05A15.6125,15.6125,0,0,1,488.391,555.67Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#ff6257"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.1428,354.4447a3.9024,3.9024,0,1,1-3.9023-3.9023A3.9023,3.9023,0,0,1,564.1428,354.4447Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#38352d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.363,
    cy: 248.1779,
    r: 14.5095,
    style: {
      fill: "#f44336"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.8994,371.1227A14.5029,14.5029,0,0,1,571.523,359.84a14.5046,14.5046,0,1,0-20.3966,20.3966A14.4422,14.4422,0,0,1,547.8994,371.1227Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#ff6257"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.6831,175.8155a3.9024,3.9024,0,1,1-3.9024-3.9023A3.9024,3.9024,0,0,1,500.6831,175.8155Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#38352d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.9032,
    cy: 69.5487,
    r: 14.5095,
    style: {
      fill: "#f44336"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.44,192.4934a14.5029,14.5029,0,0,1,23.6236-11.2825,14.5046,14.5046,0,1,0-20.3966,20.3966A14.4425,14.4425,0,0,1,484.44,192.4934Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#ff6257"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.618,660.8539a4.58,4.58,0,1,1-4.58-4.5795A4.58,4.58,0,0,1,638.618,660.8539Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#38352d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 428.161,
    cy: 557.1051,
    r: 17.0275,
    style: {
      fill: "#f44336"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.5557,680.4262a17.02,17.02,0,0,1,27.7232-13.24,17.0217,17.0217,0,1,0-23.9362,23.9362A16.9488,16.9488,0,0,1,619.5557,680.4262Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#ff6257"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242.5358,
    cy: 326.6803,
    r: 4.3334,
    style: {
      fill: "#38352d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 448.4133,
    cy: 463.5687,
    r: 16.112,
    transform: "translate(-402.3328 332.0759) rotate(-45)",
    style: {
      fill: "#4ee1e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.7092,465.9766a16.1047,16.1047,0,0,1,26.2328-12.5287,16.1066,16.1066,0,1,0-22.6494,22.6494A16.0374,16.0374,0,0,1,434.7092,465.9766Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#72f7f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.22,716.8205a3.6148,3.6148,0,1,1-3.6148-3.6147A3.6147,3.6147,0,0,1,491.22,716.8205Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#38352d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.6049,
    cy: 730.2606,
    r: 13.44,
    transform: "translate(-587.719 486.5941) rotate(-48.2234)",
    style: {
      fill: "#4ee1e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.1735,732.2691a13.4339,13.4339,0,0,1,21.8823-10.4509,13.4355,13.4355,0,1,0-18.8932,18.8932A13.378,13.378,0,0,1,476.1735,732.2691Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#72f7f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.5235,299.9089a3.6147,3.6147,0,1,1-3.6147-3.6147A3.6147,3.6147,0,0,1,532.5235,299.9089Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#38352d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528.9088,
    cy: 313.349,
    r: 13.44,
    transform: "translate(-285.2331 103.4291) rotate(-22.3068)",
    style: {
      fill: "#4ee1e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.4774,315.3576a13.4339,13.4339,0,0,1,21.8823-10.451A13.4355,13.4355,0,1,0,520.4665,323.8,13.3773,13.3773,0,0,1,517.4774,315.3576Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#72f7f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.9744,612.5564a3.6147,3.6147,0,1,1-3.6147-3.6148A3.6147,3.6147,0,0,1,542.9744,612.5564Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#38352d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.4822,
    cy: 505.2201,
    r: 13.44,
    style: {
      fill: "#4ee1e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.9283,628.005a13.4338,13.4338,0,0,1,21.8823-10.4509,13.4355,13.4355,0,1,0-18.8932,18.8932A13.3778,13.3778,0,0,1,527.9283,628.005Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#72f7f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.015,619.9909a4.1982,4.1982,0,1,1-4.1981-4.1981A4.1981,4.1981,0,0,1,398.015,619.9909Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#38352d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.9394,
    cy: 514.8239,
    r: 15.6093,
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.54,637.933a15.602,15.602,0,0,1,25.4142-12.1377,15.604,15.604,0,1,0-21.9426,21.9426A15.5369,15.5369,0,0,1,380.54,637.933Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#f9e064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.0681,317.7188A2.8185,2.8185,0,1,1,464.25,314.9,2.8184,2.8184,0,0,1,467.0681,317.7188Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#38352d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.3722,
    cy: 207.4219,
    r: 10.4794,
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.3364,329.7644a10.4746,10.4746,0,0,1,17.062-8.1488,10.4758,10.4758,0,1,0-14.7313,14.7313A10.43,10.43,0,0,1,455.3364,329.7644Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#f9e064"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 387.3522,
    cy: 383.0097,
    r: 3.8741,
    style: {
      fill: "#38352d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 387.3522,
    cy: 397.4142,
    r: 14.4045,
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.9779,520.3432a14.398,14.398,0,0,1,23.4527-11.2009,14.4,14.4,0,1,0-20.249,20.249A14.3373,14.3373,0,0,1,580.9779,520.3432Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#f9e064"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.483,
    y: 701.1519,
    width: 120.7548,
    height: 76.2419,
    style: {
      fill: "#b266cb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455.4746,
    y: 666.4441,
    width: 132.7704,
    height: 34.7088,
    style: {
      fill: "#b266cb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 511.4713,
    y: 666.443,
    width: 20.7781,
    height: 110.9508,
    style: {
      fill: "#3f407d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "582.238 747.11 461.482 706.658 461.482 701.152 582.238 701.152 582.238 747.11",
    style: {
      fill: "#e2dcd9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M726.9156,787.194l12.97-35.098a2.1717,2.1717,0,0,1,3.5858-.77l10.0136,10.1858a2.1716,2.1716,0,0,1-.08,3.1223l-24.6077,22.5873Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#3f407d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.7837,787.2217l-.3472-.7778,29.1641-17.1476a2.1717,2.1717,0,0,1,3.0822.9833l5.248,11.6991a2.1717,2.1717,0,0,1-1.8472,3.0564Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#3f407d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.559,787.194l-12.97-35.098a2.1717,2.1717,0,0,0-3.5857-.77L701.99,761.5121a2.1717,2.1717,0,0,0,.08,3.1223l24.6077,22.5873Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#3f407d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.6909,787.2217l.3472-.7778-29.164-17.1476a2.1717,2.1717,0,0,0-3.0822.9833l-5.2481,11.6991a2.1718,2.1718,0,0,0,1.8473,3.0564Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#3f407d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.5568,785.5715l-9.7759-38.573c-.4794-1.9186,1.3388-3.7106,3.7646-3.7106h12.74c2.43,0,4.2487,1.7975,3.7626,3.7182l-10.1752,38.5654Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#3f407d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.1534,787.22c-10.2378-8.8555-18.8321,0-18.8321,0Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#323263"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "521.575 662.842 520.398 641.828 520.896 640.149 521.895 640.938 522.981 640.136 523.408 641.775 522.075 662.842 521.575 662.842",
    style: {
      fill: "#323263"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "517.524 665.602 497.034 660.796 495.564 659.844 496.602 659.108 496.14 657.841 497.832 657.893 517.665 665.123 517.524 665.602",
    style: {
      fill: "#323263"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "520.117 662.634 511.114 646.666 509.737 645.894 509.737 647.022 508.373 646.963 508.49 647.996 519.769 663.347 520.117 662.634",
    style: {
      fill: "#323263"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "526.333 665.602 546.823 660.796 548.293 659.844 547.255 659.108 547.717 657.841 546.024 657.893 526.191 665.123 526.333 665.602",
    style: {
      fill: "#323263"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "523.74 662.634 532.743 646.666 534.12 645.894 534.12 647.022 535.484 646.963 535.366 647.996 524.088 663.347 523.74 662.634",
    style: {
      fill: "#323263"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455.4746,
    y: 666.4441,
    width: 132.7704,
    height: 4.7122,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.0971,
    y: 666.9588,
    width: 153.7907,
    height: 110.435,
    style: {
      fill: "#f44336"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 639.2443,
    width: 157.985,
    height: 27.7145,
    style: {
      fill: "#f44336"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.0386,
    y: 639.2443,
    width: 35.9077,
    height: 138.1495,
    style: {
      fill: "#f3d156"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.1155,
    y: 639.2443,
    width: 15.754,
    height: 138.1495,
    style: {
      fill: "#fbc02d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "155.888 699.87 2.097 673.361 2.097 666.959 155.888 666.959 155.888 699.87",
    style: {
      fill: "#bee2d6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M245.7785,756.3669c5.9076,7.4948,38.1494-1.3291,38.1494-1.3291l-39.0817-4.7495a6.2478,6.2478,0,0,0-.584,3.0608A6.79,6.79,0,0,0,245.7785,756.3669Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#f9a825"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.9356,733.18c-.4967,8.71,26.9234,22.2048,26.9234,22.2048L260.98,728.4532a5.713,5.713,0,0,0-2.2543,1.7416A6.2076,6.2076,0,0,0,257.9356,733.18Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#dbb744"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.859,755.3844s.3131-31.1163-6.2146-31.2666-18.7671,3.0845-19.3539,4.128a11.8277,11.8277,0,0,0-1.3549,4.9338s.6868-6.6055,4.181-2.3112Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#f3d156"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.859,755.3844l-5.4466-18.739s-.4527,1.7231-1.278,2.1124-2.6054-.305-2.6054-.305Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#dbb744"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.9279,755.0378s-22.3-25.7143-27.7558-21.1055-13.1362,16.131-12.86,17.4111a12.9379,12.9379,0,0,0,2.4668,5.0235s-4.2258-5.9086,1.7492-4.9239Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fbc02d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.9279,755.0378l-18.0453-11.4009s.8783,1.74.4844,2.6567-2.3551,1.639-2.3551,1.639Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#f9a825"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.9614,756.3669c-5.9076,7.4948-38.1494-1.3291-38.1494-1.3291l39.0817-4.7495a6.2478,6.2478,0,0,1,.584,3.0608A6.79,6.79,0,0,1,323.9614,756.3669Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#f9a825"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.8044,733.18c.4966,8.71-26.9235,22.2048-26.9235,22.2048L308.76,728.4532a5.7123,5.7123,0,0,1,2.2543,1.7416A6.209,6.209,0,0,1,311.8044,733.18Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#dbb744"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.8809,755.3844s-.313-31.1163,6.2146-31.2666,18.7671,3.0845,19.354,4.128a11.8294,11.8294,0,0,1,1.3549,4.9338s-.6869-6.6055-4.181-2.3112Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#f3d156"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.8809,755.3844l5.4466-18.739s.4527,1.7231,1.278,2.1124,2.6054-.305,2.6054-.305Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#dbb744"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.812,755.0378s22.3-25.7143,27.7558-21.1055,13.1362,16.131,12.86,17.4111a12.9379,12.9379,0,0,1-2.4668,5.0235s4.2258-5.9086-1.7492-4.9239Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fbc02d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.812,755.0378l18.0454-11.4009s-.8784,1.74-.4845,2.6567,2.3551,1.639,2.3551,1.639Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#f9a825"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.0469,760.0206H272.6928c0-2.1695,7.0975-6.5259,8.1542-6.5259h8.0458a15.1221,15.1221,0,0,1,4.4733,2.451C295.2715,757.3054,297.0469,758.938,297.0469,760.0206Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#f3d156"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.691 639.244 73.294 639.244 75.299 632.718 82.686 632.718 84.691 639.244",
    style: {
      fill: "#fbc02d"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 639.2443,
    width: 157.985,
    height: 4.1536,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "472.649 665.075 469.924 704.246 466.533 774.996 466.367 777.394 405.241 777.394 399.397 671.328 399.371 670.96 398.963 665.075 472.649 665.075",
    style: {
      fill: "#c2185b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.2408,
    y: 641.5352,
    width: 79.1301,
    height: 23.5397,
    style: {
      fill: "#c2185b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.3595,
    y: 641.5352,
    width: 22.892,
    height: 135.8585,
    style: {
      fill: "#ffe3fc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.3465,
    y: 641.5352,
    width: 1.0502,
    height: 135.8585,
    style: {
      fill: "#c2185b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.2143,
    y: 641.5352,
    width: 1.0502,
    height: 135.8585,
    style: {
      fill: "#c2185b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "472.649 665.075 469.924 704.246 399.371 670.96 398.963 665.075 472.649 665.075",
    style: {
      fill: "#e2d9df",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.0539,757.2468l.6106.6143c-.2427-.2391-.4818-.4782-.7209-.7062C639.98,757.1843,640.0172,757.2137,640.0539,757.2468Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#6339d3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.004 637.302 434.791 637.088 434.971 637.265 435.004 637.302",
    style: {
      fill: "#6339d3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.6318,760.3254c-.0294-.4488-.0588-.89-.0919-1.3241.0073.0478.0147.0993.0221.1508Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#6339d3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.4817,759.2082c5.0177,6.3658,32.4028-1.1289,32.4028-1.1289l-33.1946-4.034a5.3069,5.3069,0,0,0-.496,2.6A5.7679,5.7679,0,0,0,608.4817,759.2082Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#f2aff0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.8075,739.5138c-.4218,7.3984,22.8678,18.86,22.8678,18.86l-20.2817-22.8744a4.8513,4.8513,0,0,0-1.9147,1.4793A5.2732,5.2732,0,0,0,618.8075,739.5138Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#f2aff0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.6739,758.3723l-.0037-.0037-.1912-.2059-.0037-.0037-.0625-.07-.0037-.0037-.2759-.2942-.1581-.1729L622.36,737.5507c-2.7622-3.3948-3.461,1.2322-3.5456,1.8869,0,.0147-.0037.0294-.0037.04a.2992.2992,0,0,0-.0037.0368s.0037-.0809.0147-.2243q.0055-.0607.0111-.1325c.0036-.0441.0073-.0919.0147-.1434a9.8633,9.8633,0,0,1,1.1107-3.6928,2.8335,2.8335,0,0,1,1.1439-.6326c.3237-.1251.7062-.2612,1.14-.4046a59.7308,59.7308,0,0,1,11.9648-2.3981c.3678-.0258.7209-.0478,1.0667-.0589.39-.0147.765-.0183,1.1218-.011C641.9424,731.9453,641.6739,758.3723,641.6739,758.3723Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#ffe3fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.6753,758.3737l-4.6261-15.9163s-.3845,1.4636-1.0855,1.7942-2.213-.259-2.213-.259Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#f2aff0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.8831,758.0781l-2.1333-.21-.1177-.011-28.6632-2.8321c-4.77-.7835-1.8869,3.5971-1.5264,4.13a.4172.4172,0,0,1-.0294-.0367.9044.9044,0,0,0-.0773-.0993v-.0037c-.0257-.0368-.0588-.0736-.0882-.1177-.0846-.114-.1876-.2538-.2943-.4193a10.4052,10.4052,0,0,1-1.5669-3.5383,2.0738,2.0738,0,0,1,.2833-.949c.1471-.3163.342-.6915.5885-1.1181a63.4134,63.4134,0,0,1,8.6214-11.391c.2721-.2759.5443-.537.8128-.78.21-.1949.4156-.3751.6179-.548a2.1506,2.1506,0,0,1,1.49-.4671c5.8812.1287,20.2147,16.2644,21.9139,18.1991l.0037.0037c.0589.07.103.1177.1324.1508Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#ffe3fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.8845,758.0793l-15.3271-9.6835s.7461,1.4776.4115,2.2565-2,1.392-2,1.392Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#f2aff0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.33,741.81c3.9907,1.8832,11.2476,6.1645,20.6156,15.345-9.4159-8.0808-15.8746-12.042-19.8138-13.98a23.8278,23.8278,0,0,0-4.2518-1.6919c.2721-.2759.5443-.537.8128-.78A28.44,28.44,0,0,1,619.33,741.81Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#c2185b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.9632,757.9346l-.3311-.0772-.4376-.1067-.6363-.1508c-18.3132-4.3732-27.3649-4.0753-30.8885-3.6082.1471-.3163.342-.6915.5885-1.1181,4.27-.3457,14.6534-.331,31.2415,4.9139.0846.0257.1656.0515.25.0809C638.82,757.8905,638.8933,757.9126,638.9632,757.9346Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#c2185b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.4863,758.28c.0221.239.04.4781.0552.7209-.0331-.2538-.07-.5039-.1067-.75-.0073-.0551-.0147-.11-.022-.1618l-.0037-.0037v-.011c-.011-.0846-.0221-.1692-.0368-.25-.0478-.3384-.0956-.6694-.1471-1-2.4055-15.8083-5.6164-22.5944-7.0178-24.9373.3678-.0258.7209-.0478,1.0667-.0589,1.4859,2.8616,4.8881,10.8283,6.15,25.6877.0147.1582.0294.3163.04.4745a1.1525,1.1525,0,0,1,.011.1582v.011l.0037.0037C641.4827,758.2031,641.4863,758.24,641.4863,758.28Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#c2185b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.365,758.1774l-.39-.5591-.1177-.1655-.32-.46c-9.4711-13.55-15.9923-19.6666-19.435-22.3038.3237-.1251.7062-.2612,1.14-.4046,3.8363,3.1521,10.8724,10.0779,18.8428,23.422.0148.0294.0331.0552.0478.0846Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#c2185b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.8842,759.2082c-5.0177,6.3658-32.4027-1.1289-32.4027-1.1289l33.1945-4.034a5.3064,5.3064,0,0,1,.4961,2.6A5.7689,5.7689,0,0,1,674.8842,759.2082Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#f2aff0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.5584,739.5138c.4218,7.3984-22.8677,18.86-22.8677,18.86l20.2816-22.8744a4.852,4.852,0,0,1,1.9148,1.4793A5.2729,5.2729,0,0,1,664.5584,739.5138Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#f2aff0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.692,758.3723l.0037-.0037.1913-.2059.0036-.0037.0626-.07.0036-.0037.2759-.2942.1581-.1729,18.6148-20.0676c2.7622-3.3948,3.4611,1.2322,3.5457,1.8869,0,.0147.0036.0294.0036.04a.2992.2992,0,0,1,.0037.0368s-.0037-.0809-.0147-.2243q-.0055-.0607-.011-.1325c-.0037-.0441-.0074-.0919-.0147-.1434a9.8657,9.8657,0,0,0-1.1108-3.6928,2.8327,2.8327,0,0,0-1.1439-.6326c-.3237-.1251-.7062-.2612-1.14-.4046a59.7293,59.7293,0,0,0-11.9648-2.3981c-.3678-.0258-.7209-.0478-1.0666-.0589-.39-.0147-.7651-.0183-1.1218-.011C641.4235,731.9453,641.692,758.3723,641.692,758.3723Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#ffe3fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.6907,758.3737l4.6261-15.9163s.3845,1.4636,1.0855,1.7942,2.2129-.259,2.2129-.259Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#f2aff0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.4828,758.0781l2.1333-.21.1177-.011,28.6632-2.8321c4.77-.7835,1.8869,3.5971,1.5264,4.13a.4151.4151,0,0,0,.0295-.0367.9031.9031,0,0,1,.0772-.0993v-.0037c.0257-.0368.0588-.0736.0883-.1177.0846-.114.1876-.2538.2942-.4193a10.4052,10.4052,0,0,0,1.5669-3.5383,2.0745,2.0745,0,0,0-.2832-.949c-.1472-.3163-.3421-.6915-.5885-1.1181a63.4228,63.4228,0,0,0-8.6214-11.391c-.2722-.2759-.5444-.537-.8129-.78-.21-.1949-.4156-.3751-.6179-.548a2.15,2.15,0,0,0-1.49-.4671c-5.8813.1287-20.2147,16.2644-21.914,18.1991l-.0037.0037c-.0588.07-.103.1177-.1324.1508Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#ffe3fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.4815,758.0793l15.327-9.6835s-.746,1.4776-.4114,2.2565,2,1.392,2,1.392Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#f2aff0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.0363,741.81c-3.9907,1.8832-11.2475,6.1645-20.6156,15.345,9.4159-8.0808,15.8746-12.042,19.8138-13.98a23.8307,23.8307,0,0,1,4.2519-1.6919c-.2722-.2759-.5444-.537-.8129-.78A28.4512,28.4512,0,0,0,664.0363,741.81Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#c2185b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.4028,757.9346l.331-.0772.4377-.1067.6363-.1508c18.3131-4.3732,27.3649-4.0753,30.8885-3.6082-.1472-.3163-.3421-.6915-.5885-1.1181-4.27-.3457-14.6535-.331-31.2416,4.9139-.0846.0257-.1655.0515-.25.0809C644.5462,757.8905,644.4726,757.9126,644.4028,757.9346Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#c2185b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.88,758.28c-.0221.239-.04.4781-.0552.7209.0331-.2538.07-.5039.1067-.75.0073-.0551.0147-.11.0221-.1618l.0036-.0037v-.011c.0111-.0846.0221-.1692.0368-.25.0478-.3384.0956-.6694.1471-1,2.4055-15.8083,5.6165-22.5944,7.0178-24.9373-.3678-.0258-.7209-.0478-1.0666-.0589-1.486,2.8616-4.8882,10.8283-6.15,25.6877-.0147.1582-.0294.3163-.04.4745a1.1371,1.1371,0,0,0-.0111.1582v.011l-.0036.0037C641.8833,758.2031,641.88,758.24,641.88,758.28Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#c2185b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.001,758.1774l.39-.5591.1177-.1655.32-.46c9.4711-13.55,15.9923-19.6666,19.435-22.3038-.3237-.1251-.7062-.2612-1.14-.4046-3.8362,3.1521-10.8724,10.0779-18.8428,23.422-.0147.0294-.0331.0552-.0478.0846Q642.1169,757.9843,642.001,758.1774Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#c2185b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.0242,762.3115H631.3388c0-1.5411,4.2114-4.3769,6.1167-5.267a2.4755,2.4755,0,0,1,.8091-.2758h6.8339a2.5636,2.5636,0,0,1,.8165.2795,20.539,20.539,0,0,1,2.9829,1.8023C650.5163,760.0054,652.0242,761.392,652.0242,762.3115Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#ffe3fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.7817,778.33l0-.005a3.2325,3.2325,0,0,0-6.465,0l0,.005a1.9348,1.9348,0,0,0-1.8374,1.9314v10.4122a5.07,5.07,0,0,0,10.1393,0V780.261A1.9349,1.9349,0,0,0,663.7817,778.33Zm-3.2322.2042a.9221.9221,0,1,1,.9221-.9221A.9221.9221,0,0,1,660.55,778.5338Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#ffe3fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.6344,792.1539a.2376.2376,0,0,1-.2376-.2376v-9.5122a.2377.2377,0,0,1,.4753,0v9.5122A.2377.2377,0,0,1,662.6344,792.1539Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#395a72"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.4646,792.1539a.2376.2376,0,0,1-.2376-.2376v-9.5122a.2376.2376,0,0,1,.4752,0v9.5122A.2376.2376,0,0,1,658.4646,792.1539Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#395a72"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.7321,777.2261a.1821.1821,0,0,1-.18.1876h-.0037a.1862.1862,0,0,1-.1839-.18c-.0809-4.2224-2.4533-12.0935-3.3507-14.922H657.4C658.3266,765.2466,660.6512,773.0147,660.7321,777.2261Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#395a72"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.3676,756.7687l-2.0635,5.5428h-.787l1.9384-5.267a2.4755,2.4755,0,0,1,.8091-.2758Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#c2185b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.85,762.3115h-.7872l-2.0633-5.5428h.0993a2.5636,2.5636,0,0,1,.8165.2795Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#c2185b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.2408,
    y: 641.5352,
    width: 79.1301,
    height: 3.9993,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.8618,745.4672c-18.9583-23.722-44.2992,54.09-44.2992,54.09l1.3122,4.1375S482.82,769.1892,463.8618,745.4672Zm-15.646,30.4887c-8.1091,8.4688-23.5443,18.5273-23.5443,18.5273s24.5276-46.3363,29.599-42.1933S456.3248,767.4873,448.2158,775.9559Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#21a4a8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.2261,747.1459c-14.0985,6.4163-19.699,17.11-16.8751,23.8447,5.3682,12.8031,45.2364,32.21,45.2364,32.21l.8435-4.5836S405.3245,740.73,391.2261,747.1459Zm3.663,31.0609c-11.8429-10.0961-11.1784-13.8629-3.3112-19.1675s24.3784,34.7556,24.3784,34.7556A171.7385,171.7385,0,0,1,394.8891,778.2068Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#21a4a8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.947 702.772 284.89 704.151 284.393 715.848 283.922 726.925 283.906 727.301 283.375 739.887 283.375 739.89 283.277 742.171 282.891 751.239 282.296 765.314 281.929 773.959 281.784 777.394 146.407 777.394 146.211 772.782 145.569 757.619 145.142 747.548 144.915 742.171 144.427 730.632 144.269 726.925 144.029 721.222 143.387 706.109 143.244 702.772 284.947 702.772",
    style: {
      fill: "#4ee1e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.7555,
    y: 678.7083,
    width: 160.6802,
    height: 24.0641,
    style: {
      fill: "#4ee1e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.4716,
    y: 678.7083,
    width: 15.2479,
    height: 98.6855,
    style: {
      fill: "#21a4a8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.922 726.925 283.277 742.171 144.915 742.171 144.269 726.925 283.922 726.925",
    style: {
      fill: "#21a4a8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.947 702.772 283.577 730.313 143.504 707.988 143.244 702.772 284.947 702.772",
    style: {
      fill: "#d4d6d5",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.7555,
    y: 678.7083,
    width: 160.6802,
    height: 5.1932,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.9367,
    y: 726.35,
    width: 151.9792,
    height: 51.0438,
    style: {
      fill: "#216ea8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.8194,
    y: 707.8876,
    width: 156.2139,
    height: 18.4624,
    style: {
      fill: "#216ea8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.781 777.394 299.562 777.394 278.937 756.241 278.937 732.437 322.781 777.394",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.917 777.394 375.701 777.394 325.924 726.35 307.92 707.888 331.136 707.888 349.14 726.35 398.917 777.394",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.916 737.018 430.916 760.826 397.297 726.35 387.346 716.146 379.293 707.888 402.509 707.888 410.562 716.146 420.513 726.35 430.916 737.018",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.47,823.06l.6756.68c-.2686-.2646-.5332-.5291-.7977-.7815C523.3885,822.99,523.4293,823.0228,523.47,823.06Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#39d375"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.508 703.203 318.272 702.967 318.472 703.162 318.508 703.203",
    style: {
      fill: "#39d375"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.5333,825.23c5.5524,7.0442,35.8557-1.2492,35.8557-1.2492l-36.7319-4.4639a5.8722,5.8722,0,0,0-.5489,2.8767A6.3832,6.3832,0,0,0,488.5333,825.23Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#d9c325"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.96,803.4367c-.4668,8.1869,25.3046,20.87,25.3046,20.87l-22.443-25.312a5.37,5.37,0,0,0-2.1188,1.6369A5.8335,5.8335,0,0,0,499.96,803.4367Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#d9c325"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.2626,824.3049l-.0041-.004-.2116-.228-.0041-.0041-.0692-.0773-.0041-.004-.3052-.3256-.175-.1913-20.5984-22.2061c-3.0566-3.7566-3.83,1.3635-3.9236,2.088,0,.0162-.004.0325-.004.0447a.33.33,0,0,0-.0041.0407s.0041-.09.0163-.2483q.0061-.067.0122-.1465c.0041-.0488.0081-.1017.0163-.1587a10.9135,10.9135,0,0,1,1.2291-4.0863,3.135,3.135,0,0,1,1.2658-.7c.3582-.1384.7815-.2889,1.2617-.4477A66.0947,66.0947,0,0,1,517,794.9967c.407-.0285.7978-.0529,1.18-.0651.4314-.0163.8466-.02,1.2414-.0123C525.56,795.0618,525.2626,824.3049,525.2626,824.3049Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.2641,824.3065l-5.1191-17.6124s-.4255,1.62-1.2012,1.9854-2.4487-.2866-2.4487-.2866Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#d9c325"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.3875,823.9793l-2.3606-.232-.13-.0122-31.7177-3.1339c-5.2789-.8669-2.088,3.9805-1.6891,4.5706a.4631.4631,0,0,1-.0326-.0407.9969.9969,0,0,0-.0854-.11v-.0041c-.0285-.0407-.0652-.0814-.0977-.13-.0936-.1261-.2076-.2808-.3256-.4639a11.5153,11.5153,0,0,1-1.7339-3.9154,2.296,2.296,0,0,1,.3134-1.05c.1629-.35.3785-.7651.6513-1.2373a70.1735,70.1735,0,0,1,9.54-12.6048c.3012-.3053.6024-.5943.9-.8629.2319-.2157.46-.4151.6837-.6064a2.3793,2.3793,0,0,1,1.6484-.5169c6.508.1424,22.3688,17.9976,24.2492,20.1385l.004.0041c.0652.0773.114.13.1466.1668Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.389,823.9807l-16.96-10.7154s.8256,1.635.4553,2.497-2.2135,1.54-2.2135,1.54Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#d9c325"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.0119,825.23c-5.5524,7.0442-35.8557-1.2492-35.8557-1.2492l36.7319-4.4639a5.8722,5.8722,0,0,1,.5489,2.8767A6.3832,6.3832,0,0,1,562.0119,825.23Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#d9c325"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.5857,803.4367c.4668,8.1869-25.3046,20.87-25.3046,20.87l22.4429-25.312a5.369,5.369,0,0,1,2.1188,1.6369A5.8338,5.8338,0,0,1,550.5857,803.4367Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#d9c325"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.2826,824.3049l.004-.004.2117-.228.0041-.0041.0692-.0773.004-.004.3053-.3256.175-.1913,20.5984-22.2061c3.0566-3.7566,3.83,1.3635,3.9235,2.088,0,.0162.0041.0325.0041.0447a.3377.3377,0,0,1,.004.0407s-.004-.09-.0163-.2483q-.006-.067-.0122-.1465c-.004-.0488-.0081-.1017-.0163-.1587a10.9116,10.9116,0,0,0-1.2291-4.0863,3.1342,3.1342,0,0,0-1.2658-.7c-.3581-.1384-.7814-.2889-1.2617-.4477a66.0932,66.0932,0,0,0-13.24-2.6536c-.407-.0285-.7977-.0529-1.18-.0651-.4315-.0163-.8466-.02-1.2414-.0123C524.9855,795.0618,525.2826,824.3049,525.2826,824.3049Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.2811,824.3065,530.4,806.6941s.4254,1.62,1.2011,1.9854,2.4488-.2866,2.4488-.2866Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#d9c325"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.1576,823.9793l2.3607-.232.13-.0122,31.7177-3.1339c5.2788-.8669,2.0879,3.9805,1.6891,4.5706a.4652.4652,0,0,0,.0325-.0407,1.0106,1.0106,0,0,1,.0855-.11v-.0041c.0285-.0407.0651-.0814.0977-.13.0936-.1261.2075-.2808.3256-.4639a11.5135,11.5135,0,0,0,1.7338-3.9154,2.2947,2.2947,0,0,0-.3134-1.05c-.1628-.35-.3785-.7651-.6512-1.2373a70.1735,70.1735,0,0,0-9.54-12.6048c-.3012-.3053-.6024-.5943-.8995-.8629-.232-.2157-.46-.4151-.6838-.6064a2.3789,2.3789,0,0,0-1.6484-.5169c-6.5079.1424-22.3688,17.9976-24.2491,20.1385l-.0041.0041c-.0651.0773-.114.13-.1465.1668Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.1562,823.9807l16.96-10.7154s-.8255,1.635-.4553,2.497,2.2136,1.54,2.2136,1.54Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#d9c325"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.7174,828.6639h-22.89c0-2.0391,6.6708-6.1335,7.6639-6.1335h7.5621a14.212,14.212,0,0,1,4.2043,2.3036C535.0487,826.112,536.7174,827.6464,536.7174,828.6639Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fee52b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.915 762.095 278.937 732.867 278.937 726.351 430.915 726.351 430.915 762.095",
    style: {
      fill: "#d1d1d1",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.4322,845.8386l0-.0053a3.4659,3.4659,0,1,0-6.9318,0l0,.0053a2.0745,2.0745,0,0,0-1.97,2.0709v11.1639a5.4357,5.4357,0,1,0,10.8714,0V847.91A2.0745,2.0745,0,0,0,547.4322,845.8386Zm-3.4657.2189a.9887.9887,0,1,1,.9888-.9886A.9886.9886,0,0,1,543.9665,846.0575Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.202,860.6611a.2548.2548,0,0,1-.2548-.2548v-10.199a.2548.2548,0,0,1,.51,0v10.199A.2548.2548,0,0,1,546.202,860.6611Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#545253"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.7311,860.6611a.2548.2548,0,0,1-.2548-.2548v-10.199a.2548.2548,0,1,1,.51,0v10.199A.2548.2548,0,0,1,541.7311,860.6611Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#545253"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.1623,844.6555a.1952.1952,0,0,1-.1932.2011h-.0039a.2.2,0,0,1-.1972-.1933c-.0868-4.5273-2.63-12.9667-3.5927-15.9994h.414C541.5832,831.8109,544.0756,840.14,544.1623,844.6555Z",
    transform: "translate(-205.8775 -120.7763)",
    style: {
      fill: "#545253"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.8194,
    y: 707.8876,
    width: 156.2139,
    height: 3.4701,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconChristmasTree, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-christmas-tree.0f513a09.svg";
export { ForwardRef as ReactComponent };